import React from "react"
import { cn } from "@/lib/utils"

const Button = React.forwardRef(({ className, variant = "primary", size = "md", asChild = false, as, children, ...props }, ref) => {
  const baseClasses = "inline-flex items-center justify-center rounded-full font-semibold ring-1 transition relative overflow-hidden group"

  const sizeClasses = {
    sm: "px-4 py-2 text-sm",
    md: "px-5 py-2.5",
    lg: "px-6 py-3 text-base"
  }

  const variantClasses = {
    primary: "bg-orange-500 text-white ring-1 ring-orange-500/20 hover:bg-orange-600 hover:ring-orange-500/30",
    secondary: "bg-orange-50 text-orange-700 ring-1 ring-orange-200 hover:bg-orange-100 hover:ring-orange-300",
    ghost: "bg-transparent text-orange-600 ring-1 ring-transparent hover:bg-orange-50 hover:ring-orange-200",
    white: "bg-white text-orange-600 ring-1 ring-orange-200 hover:bg-orange-50 hover:ring-orange-300",
    dark: "bg-neutral-900 text-white ring-1 ring-neutral-300/20 hover:bg-neutral-800 hover:ring-neutral-300/30"
  }

  const Component = as || (asChild ? "div" : "button")

  // Check if this is the "Book a Call" button (hero section only)
  const isBookCallButton = children === "Book a Call" || children === "Book a call"

  return (
    <Component
      className={cn(
        baseClasses,
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      ref={ref}
      {...props}
    >
      {isBookCallButton ? (
        <div className="relative overflow-hidden">
          <span className="block transition-transform duration-300 ease-out group-hover:-translate-y-full">
            {children}
          </span>
          <span className="absolute inset-0 flex items-center justify-center transition-all duration-300 ease-out opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-4">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" className="w-4 h-4" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
              <path fill="currentColor" d="M6 6v2h8.59L5 17.59L6.41 19L16 9.41V18h2V6z"></path>
            </svg>
          </span>
        </div>
      ) : (
        children
      )}
    </Component>
  )
})
Button.displayName = "Button"

export { Button }
